import cn from 'classnames';
import {
  IconClose,
  IconError,
  IconInfo,
  IconSuccess,
  IconWarning,
} from '~/icons';

import css from './Toast.module.css';

const iconMap = {
  success: <IconSuccess />,
  error: <IconError />,
  warning: <IconWarning />,
  info: <IconInfo />,
};

interface ToastProps {
  id: string;
  title?: string;
  description: string;
  type: 'error' | 'success' | 'info' | 'warning';
  onClose: () => void;
}

export function Toast({ title, description, type, onClose }: ToastProps) {
  return (
    <div className={css.toast}>
      <div className={cn(css.toastIcon, css[`toast--${type}`])}>
        {iconMap[type]}
      </div>
      <div className={css.toastContent}>
        <div className={css.toastHeader}>
          <div className={css.toastMessage}>
            {title && <span className={css.toastTitle}>{title}</span>}
          </div>
          <button
            className={css.closeButton}
            onClick={onClose}
            aria-label="Close"
          >
            <IconClose />
          </button>
        </div>
        <p className={css.toastDescription}>{description}</p>
      </div>
    </div>
  );
}
